import React from 'react';
import CrudPage from '../../components/CrudPage';
import { earnXpApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'earnXpId' },
  { header: 'Name', field: 'name' },
  { header: 'XP Points', field: 'xpPoints' },
  { header: 'Description', field: 'description' },
  { header: 'Active', field: 'isActive', render: (v) => v ? 'Yes' : 'No' },
];

const formFields = [
  { name: 'name', label: 'Name', type: 'text', required: true },
  { name: 'xpPoints', label: 'XP Points', type: 'number', required: true },
  { name: 'description', label: 'Description', type: 'textarea' },
  { name: 'isActive', label: 'Active', type: 'checkbox' },
];

const EarnXpPage = () => (
  <CrudPage
    title="Earn XP"
    subtitle="Manage XP earning activities"
    api={earnXpApi}
    columns={columns}
    formFields={formFields}
    idField="earnXpId"
    searchField="name"
  />
);

export default EarnXpPage;
